<template>
  <toolbar-actions>
    <btn @click="$root.deviceEmulator = true" :class="['mr-1', 'hidden', 'lg:inline-block']" :color="color" :elevation="elevation" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" :title="$lang.deviceEmulator" :color-lightness="colorLightness" icon="cellphone-link" /><!--
    --><btn hidden :class="['mr-1']" @click="toggleFullScreen" :color="color" :elevation="elevation" :bg-color="bgColor" :icon="`fullscreen${fullScreen ? '-exit' : '' }`" :title="$lang.fullScreen(fullScreen)" :bg-color-lightness="bgColorLightness" :color-lightness="colorLightness" /><!--
    --><btn :class="['mr-1']" to="/getting-started/bcq-bundler" icon="package-variant" :color="color" :elevation="elevation" tag="router-link" :bg-color="bgColor" :title="$lang.customBuildBundler" :bg-color-lightness="bgColorLightness" :color-lightness="colorLightness" /><!--
    --><btn :class="['mr-1']" icon="bitbucket" :color="color" :elevation="elevation" tag="a" target="_blank" :bg-color="bgColor" :href="getRepoLink()" :title="$lang.repository" :bg-color-lightness="bgColorLightness" :color-lightness="colorLightness" /><!--
    --><btn hidden :class="['mr-1']" to="/" icon="home" :color="color" :elevation="elevation" tag="router-link" :bg-color="bgColor" :title="$lang.home" :bg-color-lightness="bgColorLightness" :color-lightness="colorLightness" />
  </toolbar-actions>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'AppToolbarActions',
  mixins: [
    methods
  ],
  data () {
    return {
      fullScreen: false,
      color: 'white',
      elevation: 'none',
      bgColor: 'transparent',
      bgColorLightness: null,
      colorLightness: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-toolbar-actions.vue